require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./jackson-county-day-reporting-managing.json") })
        }
      }, "path---jackson-county-day-reporting-managing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---jackson-county-day-reporting-managing!./.cache/json/jackson-county-day-reporting-managing.json
// module id = 911
// module chunks = 231608221292675